import script from "./DragAndDropFile.vue?vue&type=script&setup=true&lang=js"
export * from "./DragAndDropFile.vue?vue&type=script&setup=true&lang=js"

import "./DragAndDropFile.vue?vue&type=style&index=0&id=56181dce&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/tests-frontend/tests-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56181dce"]])

export default __exports__